import type { SearchResult } from '@/api/types'

export function providerArtistHref(provider: string, externalId: string): string {
  return `/artists/provider/${encodeURIComponent(provider)}/${encodeURIComponent(externalId)}`
}

export function artistHref(track: { local_artist_id?: string | null; artist_id?: number | null }): string | undefined {
  if (track.local_artist_id) return `/artists/local/${encodeURIComponent(track.local_artist_id)}`
  return track.artist_id ? `/artists/${track.artist_id}` : undefined
}

export function artistSummaryHref(artist: { local_artist_id?: string | null; provider: string; external_id: string }): string {
  return artistHref(artist) ?? providerArtistHref(artist.provider, artist.external_id)
}

export function similarHref(artist: { local_artist_id?: string | null; artist_id?: number | null }): string {
  return artist.local_artist_id ? `/similar/local/${encodeURIComponent(artist.local_artist_id)}` : `/similar/${artist.artist_id}`
}

export function albumHref(album: { release_id?: string | null; provider?: string | null; external_id?: string | null; id?: number | null }): string {
  if (album.release_id) return `/albums/local/${encodeURIComponent(album.release_id)}`
  if (album.provider && album.external_id) return `/albums/${encodeURIComponent(album.provider)}/${encodeURIComponent(album.external_id)}`
  return `/library/albums/${album.id ?? 'singles'}`
}

export function searchArtistHref(result: SearchResult): string | undefined {
  const local = artistHref(result)
  if (local) return local
  if (result.artist_external_id) return providerArtistHref(result.provider, result.artist_external_id)
  return undefined
}
